import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-3">
            编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选热门漫画作品，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="px-2 py-0.5 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}